import styled, { css } from "styled-components";
import {
  DAVYS_GREY_400,
  DAVYS_GREY_500,
  MOSS_GREEN_800,
  white,
} from "./colors";
import { FiCheck } from "react-icons/fi";

const Container = styled.div`
  padding: ${({ padding }) => padding};
  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      cursor: not-allowed;
    `}
`;

const Wrapper = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: ${({ borderRadius }) => borderRadius};
  border: 1px solid ${MOSS_GREEN_800};
  background-color: ${props => (props.check ? MOSS_GREEN_800 : "none")};

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      border: 1px solid ${DAVYS_GREY_400};
      cursor: not-allowed;
      background-color: ${props => (props.check ? DAVYS_GREY_500 : "none")};
    `}
`;

const CheckBox = ({
  check,
  disabled,
  onClick,
  id,
  width = "1.5rem",
  height = "1.5rem",
  padding = "0.25rem",
  borderRadius = "0.25rem",
  iconSize = "1rem",
}) => (
  //Container adds extra padding around it to ensure the minimum interactive target space
  <Container disabled={disabled} onClick={onClick} padding={padding}>
    <Wrapper
      id={`${id}-checkbox`}
      check={check}
      disabled={disabled}
      width={width}
      height={height}
      borderRadius={borderRadius}
    >
      {check && <FiCheck id={`${id}-icon`} color={white} strokeWidth={3} size={iconSize} />}
    </Wrapper>
  </Container>
);

export default CheckBox;
